import Tab, {TabGroup} from "@amzn/meridian/tab";
import {FormattedMessage} from "react-intl";
import React, {Component} from "react";
import {matchPath, Route} from "react-router-dom";

/**
 * Custom hook that checks which route matches the current location
 * and returns its name in the object
 * @param routes
 * @param location
 * @returns Object
 */
const useCurrentRoute = (routes, location) => {
    const currentPath = location.pathname;
    const {name} = routes.find(route => !!(matchPath(currentPath, {
        path: route.path
    }))) || {};
    return {name: name};
}

/**
 * Returns Route components from a list of routes
 * @param routes
 * @returns JSX.Element
 */
export const NavigationRoutes = ({routes}) => {
    return(
        routes.map(({path, component}) =>
            (<Route key={path} path={path} component={component}/>)
        )
    )
}

/**
 * Component that handles the tab UI and changes
 * @param routes
 * @returns JSX.Element
 */
class Navigation extends Component {
    state = useCurrentRoute(this.props.routes, this.props.location);

    onTabChange = (selectedTab) => {
        this.props.routes.forEach(({name, path}) => {
            if (name === selectedTab) {
                this.setState({name: name});
                this.props.history.push(path);
            }
        })
    };

    render() {
        return (
            <TabGroup value={this.state.name} onChange={this.onTabChange} fill="line">
                {
                    this.props.routes.map(({name, id}) =>
                        (<Tab key={name} value={name}>
                            <FormattedMessage id={id} />
                        </Tab>)
                    )
                }
            </TabGroup>
        )
    }
}

export default Navigation


// WEBPACK FOOTER //
// ./src/components/util/Navigation.js